import { Button, Card, Drawer } from 'antd'
import _ from 'lodash'
import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import {
  chooseEmailModalFxn,
  DisciplineFilter,
  DisplayDate
} from '../../../../components/_utils/appUtils'
import { getAllMember } from '../../../members/actions'
import { addReviewerInAbstract } from '../../views/actions'
import ViewMember from '../../../article/articleView/viewMember'
import DeleteReviewerDrawer from '../../../article/drawers/DeleteReviewerDrawer'
import MemberHistory from '../../../article/reviewer/memberHistory'
import AbstractInfo from '../abstractPages/AbstractInfo';

const SelectAbstractReviewer = props => {
  let { visible, onClose, abstract, page } = props
  let [reviewerId, setReviewerId] = useState('')
  let [reviewerData, setReviewerData] = useState({})
  let [memberDrawerVisible, setMemberDrawerVisible] = useState(false)
  let [reviewerDrawerVisible, setReviewerDrawerVisible] = useState(false)
  let [ids, setIds] = useState(props.ids)
  const table = useRef()
  const dispatch = useDispatch()

  const columns = [
    { title: 'Reviewer ID', key: 'reviewerId', dataIndex: 'reviewerId', render: (item, record) => <ViewMember revId={record._id}><a>{record.reviewerId}</a></ViewMember> },
    { title: 'Name', key: 'name', dataIndex: 'name', filterRegex: true, searchTextName: 'name' },
    { title: 'Designation', key: 'designation', dataIndex: 'designation' },
    { title: 'Area Of Interest', key: 'areaOfInterest', dataIndex: 'areaOfInterest', searchTextName: 'areaOfInterest', filterRegex: true },
    { title: 'Email', key: 'email', dataIndex: 'email', filterRegex: true, searchTextName: 'name' },
    { title: 'Discipline', key: 'category', dataIndex: 'category', filters: DisciplineFilter.map(x => ({ text: x, value: x })) },
    { title: 'Member Type', key: 'memberType', dataIndex: 'memberType' },
    { title: 'Status', key: 'status', dataIndex: 'status' },
    { title: 'Rating', key: 'rating', dataIndex: 'rating', filterRegex: true, searchTextName: 'rating', render: item => `${item} stars` },
    { title: 'Date of Enter', key: 'createdAt', dataIndex: 'createdAt', width: 100, render: item => item ? DisplayDate(item) : null },
    {
      title: 'Action',
      key: 'actions',
      render: (val, record) => (
        <React.Fragment>
          {!ids[record._id] ? (
            <Button className={'roundSmallBtn'} onClick={() => events.selectReviewer(record._id)}>Select</Button>
          ) : null}
          <Button className={'roundSmallBtn'} onClick={() => events.showMemberHistory(record)}>History</Button>
        </React.Fragment>
      )
    }
  ]

  const apiRequest = params => {
    return new Promise(async resolve => {
      let data = await dispatch(getAllMember({ ...params, customQuery: { deleteStatus: { $ne: 'true' } } }))
      resolve(data)
    })
  }

  const events = {
    reloadTable: async selectedReviewer => {
      let ids = {}
      _.each(selectedReviewer, function(value) {
        if (value.reviewerId) {
          ids[value.reviewerId] = true
        }
      })
      setIds(ids)
      table.current.reload()
    },
    selectReviewer: id => {
      chooseEmailModalFxn({
        callback: async email => {
          let obj = {
            id: abstract._id,
            abstractId: abstract._id,
            reviewerId: id,
            fromEmail: email,
            template: 'requestToNewReviewer',
            type: 'abstract'
          }
          let { success, selectedReviewer } = await dispatch(addReviewerInAbstract(obj))
          if (success) {
            if (page && page == 'abstractView') {
              dispatch({ type: 'START_LOAD_ABSTRACT' })
            }
            events.reloadTable(selectedReviewer)
          }
        }
      })
    },
    showMemberHistory: data => {
      setMemberDrawerVisible(true)
      setReviewerData(data)
      setReviewerId(data._id)
    },
    hideMemberHistory: () => {
      setMemberDrawerVisible(false)
      setReviewerId('')
    }
  }
  return (
    <Drawer
      title={`Reviewers | Abstract ID: ${abstract.onlineAbstractId}`}
      width={'95%'}
      visible={visible}
      placement="right"
      onClose={onClose}>
      <Card>
        <AbstractInfo abstract={abstract} />
        <TableComp ref={table} columns={columns} apiRequest={apiRequest} />
      </Card>

      {memberDrawerVisible && (
        <MemberHistory
          visible={memberDrawerVisible}
          reviewerId={reviewerId}
          data={reviewerData}
          onClose={events.hideMemberHistory}
        />
      )}
    </Drawer>
  )
}

export { SelectAbstractReviewer }
